import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { RateCalendar } from "../components/RateCalendar";
import { toast } from "sonner";
import { Copy, BadgePercent } from "lucide-react";

const OFFERS = [
  { code: "EUROPCAR10", title: "10% off any rental", text: "Applies to daily, weekly and monthly bookings. Stack it with your online price.", badge: "Most popular" },
  { code: "WELCOME50", title: "AED 50 off your first booking", text: "A welcome from us to you. Valid on any rental over AED 200.", badge: "New customers" },
  { code: "UAESUMMER", title: "15% summer special", text: "Beat the heat with our strongest seasonal discount across the full fleet.", badge: "Limited season" },
];

export default function Offers() {
  const { t } = useTranslation();
  const copy = (code) => {
    navigator.clipboard?.writeText(code);
    toast.success(t("{{code}} copied — paste it at booking review", { code }));
  };
  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <div className="bg-[#144733]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 promo-stripe">
          <h1 className="heading-upper text-2xl sm:text-3xl text-white" data-testid="offers-heading">{t("Offers & promotions")}</h1>
          <p className="text-white/80 text-sm mt-2 max-w-xl">{t("Genuine discounts, plainly stated. Apply any code on the booking review step — it discounts before VAT.")}</p>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-10 w-full flex-1">
        <div className="grid md:grid-cols-3 gap-6" data-testid="offers-grid">
          {OFFERS.map((o) => (
            <div key={o.code} className="bg-white rounded-2xl border border-[#E2E8F0] p-6 card-lift flex flex-col" data-testid={`offer-${o.code}`}>
              <span className="text-[10px] uppercase tracking-widest font-semibold text-[#009900] flex items-center gap-1.5"><BadgePercent className="w-3.5 h-3.5" /> {t(o.badge)}</span>
              <h2 className="font-bold text-lg text-[#0F1E17] mt-2">{t(o.title)}</h2>
              <p className="text-sm text-[#57685e] mt-1 flex-1">{t(o.text)}</p>
              <div className="mt-4 flex items-center gap-2">
                <code className="bg-[#f4f7f4] border border-dashed border-[#009900] text-[#144733] font-bold rounded px-3 py-2 text-sm flex-1 text-center">{o.code}</code>
                <button onClick={() => copy(o.code)} className="btn-cta rounded px-3 py-2.5" data-testid={`copy-${o.code}`}><Copy className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <div className="promo-stripe mb-5">
            <h2 className="heading-upper text-xl text-[#144733]">{t("Live rate calendar")}</h2>
            <p className="text-sm text-[#57685e] mt-1">{t("Rates move with demand — green days are your cheapest start dates.")}</p>
          </div>
          <RateCalendar onPick={() => {}} />
          <div className="mt-6 text-center">
            <Link to="/#book" className="btn-cta rounded px-8 py-3.5 text-sm inline-block" data-testid="offers-book-cta">{t("Book with your code")}</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
